// removed by extract-text-webpack-plugin
module.exports = {"root":"QuestionAnswer__root___1w7_P","question":"QuestionAnswer__question___1CLKU","count":"QuestionAnswer__count___ejuKA","resultPresenter":"QuestionAnswer__resultPresenter___ogJzj","correct":"QuestionAnswer__correct___3yZgB"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/interaction/children/sections/question/childcomponents/QuestionAnswer.scss
// module id = 988
// module chunks = 0